import { DEFAULT_SETTINGS, Editor, type EditorHost } from "./editor";
import { EraserTool } from "./tools/eraser";
import { HandTool, LaserTool } from "./tools/misc";
import { PenTool } from "./tools/pen";
import { LassoTool, SelectTool } from "./tools/select";
import { CardTool, FrameTool, LineTool, NoteTool, ShapeTool, StickerTool, TextTool } from "./tools/create";
import { stickerInfo } from "../data/stickers";

export function createEditor(host: EditorHost): Editor {
  const ed = new Editor(host);
  ed.registerTool(new SelectTool(ed));
  ed.registerTool(new HandTool(ed));
  ed.registerTool(new PenTool(ed, "pen"));
  ed.registerTool(new PenTool(ed, "highlighter"));
  ed.registerTool(new EraserTool(ed));
  ed.registerTool(new LassoTool(ed));
  ed.registerTool(new ShapeTool(ed));
  ed.registerTool(new LineTool(ed));
  ed.registerTool(new TextTool(ed));
  ed.registerTool(new NoteTool(ed));
  ed.registerTool(new CardTool(ed));
  ed.registerTool(new FrameTool(ed));
  ed.registerTool(new StickerTool(ed, (key) => stickerInfo(key) ?? null));
  ed.registerTool(new LaserTool(ed));
  try {
    const saved = JSON.parse(localStorage.getItem("sepia.settings") || "null");
    if (saved && typeof saved === "object") ed.settings = { ...DEFAULT_SETTINGS, ...saved };
    if (ed.settings.writeWith === "keyboard") ed.ui = { ...ed.ui, tool: "text" };
    const style = JSON.parse(localStorage.getItem("sepia.style") || "null");
    if (style && typeof style === "object") ed.style = { ...ed.style, ...style, penSize: { ...ed.style.penSize, ...(style.penSize || {}) } };
  } catch {
    /* ignore corrupt settings */
  }
  // remember pen/colour choices between sessions
  let t = 0;
  ed.subscribeStyle(() => {
    window.clearTimeout(t);
    t = window.setTimeout(() => {
      try {
        const { stickerKey: _s, ...keep } = ed.style;
        localStorage.setItem("sepia.style", JSON.stringify(keep));
      } catch {
        /* private mode */
      }
    }, 400);
  });
  return ed;
}
